<template>
  <div>
    <img v-if="mediaFile" :src="mediaFile" alt="" />
  </div>
</template>

<script>
export default {
  name: 'PhotoBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mediaFile: null
    }
  },
  watch: {
    block: {
      handler(newBlock) {
        if (newBlock?.data?.media) {
          this.mediaFile = newBlock.data.media.preview_url
        }
      },
      immediate: true
    }
  }
}
</script> 